/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Pairing_Style_SwissInputs */



/**
* | output |
* | --- |
* | "Swiss rounds" |
*
* @param {Tournaments_Lib_Pairing_Style_SwissInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_pairing_style_swiss = /** @type {((inputs?: Tournaments_Lib_Pairing_Style_SwissInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Pairing_Style_SwissInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schweizer Runden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes suisses")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("瑞士轮")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("瑞士制")
	if (locale === "ko") return /** @type {LocalizedString} */ ("스위스 라운드")
	return /** @type {LocalizedString} */ ("Swiss rounds")
});